import {
  GET_ALERTS,
  GET_ALERTS_FAIL,
  GET_ALERTS_SUCCESS,
  GET_AWS_MISSING_ALERTS_BY_RESOURCE_ID,
  GET_AWS_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
  GET_AWS_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
  GET_AWS_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  GET_AWS_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
  GET_AWS_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
  GET_AWS_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
  GET_AWS_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_FAIL,
  GET_AWS_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_SUCCESS,
  DEPLOY_AWS_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  DEPLOY_AWS_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
  DEPLOY_AWS_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
  GET_AWS_RESOURCE_BY_RESOURCE_ID,
  GET_AWS_RESOURCE_BY_RESOURCE_ID_FAIL,
  GET_AWS_RESOURCE_BY_RESOURCE_ID_SUCCESS,
  GET_DEFAULT_THRESHOLD_BY_RESOURCE_ID,
  GET_DEFAULT_THRESHOLD_BY_RESOURCE_ID_FAIL,
  GET_DEFAULT_THRESHOLD_BY_RESOURCE_ID_SUCCESS,
  GET_NR_MISSING_ALERTS_BY_RESOURCE_ID,
  GET_NR_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
  GET_NR_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
  POST_DISABLE_ALERTS,
  POST_DISABLE_ALERTS_FAIL, POST_DISABLE_ALERTS_SUCCESS,
  POST_ENABLE_ALERTS,
  POST_ENABLE_ALERTS_FAIL, POST_ENABLE_ALERTS_SUCCESS,
  POST_SERVICE_MAPPING,
  POST_SERVICE_MAPPING_FAIL,
  POST_SERVICE_MAPPING_SUCCESS,
  PUT_ALERTS,
  PUT_ALERTS_FAIL,
  PUT_ALERTS_SUCCESS,
} from "./actionTypes";

export const getMissingAWSAlertsByResourceID = data => ({
  type: GET_AWS_MISSING_ALERTS_BY_RESOURCE_ID,
  payload: data
})

export const getMissingAWSAlertsByResourceIDSuccess = resource_missing_alerts => ({
  type: GET_AWS_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
  payload: resource_missing_alerts,
})

export const getMissingAWSAlertsByResourceIDFail = error => ({
  type: GET_AWS_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
  payload: error,
})

export const getMissingAWSDynamicAlertsByResourceID = data => ({
  type: GET_AWS_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  payload: data
})

export const getMissingAWSDynamicAlertsByResourceIDSuccess = resource_missing_dynamic_alerts => ({
  type: GET_AWS_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
  payload: resource_missing_dynamic_alerts,
})

export const getMissingAWSDynamicAlertsByResourceIDFail = error => ({
  type: GET_AWS_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
  payload: error,
})

export const getAWSDynamicAlertsDeployedByResourceID = data => ({
  type: GET_AWS_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
  payload: data
})

export const getAWSDynamicAlertsDeployedByResourceIDSuccess = resource_dynamic_alerts_deployed => ({
  type: GET_AWS_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_SUCCESS,
  payload: resource_dynamic_alerts_deployed,
})

export const getAWSDynamicAlertsDeployedByResourceIDFail = error => ({
  type: GET_AWS_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_FAIL,
  payload: error,
})

export const deployAWSDynamicAlertsByResourceID = data => ({
  type: DEPLOY_AWS_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  payload: data
})

export const deployAWSDynamicAlertsByResourceIDSuccess = resource_dynamic_alerts_deployed => ({
  type: DEPLOY_AWS_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
  payload: resource_dynamic_alerts_deployed,
})

export const deployAWSDynamicAlertsByResourceIDFail = error => ({
  type: DEPLOY_AWS_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
  payload: error,
})


export const getMissingNRAlertsByResourceID = data => ({
  type: GET_NR_MISSING_ALERTS_BY_RESOURCE_ID,
  payload: data
})

export const getMissingNRAlertsByResourceIDSuccess = nr_resource_missing_alerts => ({
  type: GET_NR_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
  payload: nr_resource_missing_alerts,
})

export const getMissingNRAlertsByResourceIDFail = error => ({
  type: GET_NR_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
  payload: error,
})

export const getAWSResourceByResourceID = data => ({
  type: GET_AWS_RESOURCE_BY_RESOURCE_ID,
  payload: data
})

export const getAWSResourceByResourceIDSuccess = aws_resource => ({
  type: GET_AWS_RESOURCE_BY_RESOURCE_ID_SUCCESS,
  payload: aws_resource,
})

export const getAWSResourceByResourceIDFail = error => ({
  type: GET_AWS_RESOURCE_BY_RESOURCE_ID_FAIL,
  payload: error,
})

export const postServiceMapping = (service_mapping) => {
  return {
    type: POST_SERVICE_MAPPING,
    payload: { service_mapping }
  }
}

export const postServiceMappingFail = error => ({
  type: POST_SERVICE_MAPPING_FAIL,
  payload: error,
})

export const postServiceMappingSuccess = aws_resource => ({
  type: POST_SERVICE_MAPPING_SUCCESS,
  payload: aws_resource,
})

export const getDefaultThresholdByMonitoredResourceID = data => ({
  type: GET_DEFAULT_THRESHOLD_BY_RESOURCE_ID,
  payload: data
})

export const getDefaultThresholdByMonitoredResourceIDSuccess = default_threshold_aws_resource => ({
  type: GET_DEFAULT_THRESHOLD_BY_RESOURCE_ID_SUCCESS,
  payload: default_threshold_aws_resource,
})

export const getDefaultThresholdByMonitoredResourceIDFail = error => ({
  type: GET_DEFAULT_THRESHOLD_BY_RESOURCE_ID_FAIL,
  payload: error,
})

export const putAlerts = (alerts) => {
  return {
    type: PUT_ALERTS,
    payload: { alerts }
  }
}

export const putAlertsSuccess = alerts => ({
  type: PUT_ALERTS_SUCCESS,
  payload: alerts,
})

export const putAlertsFail = error => ({
  type: PUT_ALERTS_FAIL,
  payload: error,
})

export const getAlerts = data => ({
  type: GET_ALERTS,
  payload: data,
})

export const getAlertsSuccess = alerts => ({
  type: GET_ALERTS_SUCCESS,
  payload: alerts,
})

export const getAlertsFail = error => ({
  type: GET_ALERTS_FAIL,
  payload: error,
})

export const postDisableAlerts = (alerts) => {
  return {
    type: POST_DISABLE_ALERTS,
    payload: { alerts }
  }
}
export const postEnableAlerts = (alerts) => {
  return {
    type: POST_ENABLE_ALERTS,
    payload: { alerts }
  }
}
export const postDisableAlertsSuccess = alerts => ({
  type: POST_DISABLE_ALERTS_SUCCESS,
  payload: alerts,
})

export const postEnableAlertsSuccess = alerts => ({
  type: POST_ENABLE_ALERTS_SUCCESS,
  payload: alerts,
})

export const postEnableAlertsFail = error => ({
  type: POST_ENABLE_ALERTS_FAIL,
  payload: error,
})
export const postDisableAlertsFail = error => ({
  type: POST_DISABLE_ALERTS_FAIL,
  payload: error,
})